import { Car, Cpu, FileSearch, Gavel, HardDrive, MonitorSmartphone, Scale, ShieldAlert } from "lucide-react";

export const SERVICES = [
  { key: "supporto_remoto", icon: MonitorSmartphone, title: "Supporto tecnico remoto", tag: "Su appuntamento",
    desc: "Per autoriparatori: identificazione veicolo via AI, slot dedicato e sessione live su WhatsApp con il tecnico.", app: true },
  { key: "diagnosi_sul_posto", icon: Car, title: "Diagnosi veicolo dettagliata sul posto", tag: "In loco",
    desc: "Intervento diretto sul veicolo con diagnosi approfondita di centraline, impianti e codici errore." },
  { key: "perizia_privati", icon: FileSearch, title: "Perizia per privati", tag: "Perizie",
    desc: "Accertamento tecnico sullo stato del veicolo o su un guasto, con relazione scritta." },
  { key: "ctp", icon: Scale, title: "CTP · Consulenza Tecnica di Parte", tag: "Perizie",
    desc: "Assistenza tecnica alla parte in contenziosi e procedimenti, con analisi e relazione a supporto." },
  { key: "ctu", icon: Gavel, title: "CTU · Tribunali", tag: "Perizie",
    desc: "Consulenza tecnica d'ufficio su incarico dell'autorità giudiziaria in ambito automotive." },
  { key: "airbag_forense", icon: ShieldAlert, title: "Diagnosi forense centraline airbag", tag: "Forense",
    desc: "Estrazione e analisi dei dati registrati dalle centraline airbag con sistemi Bosch." },
  { key: "lettura_banco", icon: HardDrive, title: "Letture a banco", tag: "Forense",
    desc: "Lettura diretta delle centraline smontate dal veicolo, anche quando la lettura via presa diagnosi non è possibile." },
  { key: "ricostruzione_sinistro", icon: Cpu, title: "Supporto ricostruzione sinistro", tag: "Forense",
    desc: "Dati tecnici delle centraline a supporto della ricostruzione della dinamica di un incidente." },
];

export const QUOTE_SERVICES = SERVICES.filter((s) => !s.app);
export const BASE_REGIONS = ["Campania", "Basilicata", "Calabria"];
export const REGIONS = ["Abruzzo", "Basilicata", "Calabria", "Campania", "Emilia-Romagna", "Friuli-Venezia Giulia", "Lazio",
  "Liguria", "Lombardia", "Marche", "Molise", "Piemonte", "Puglia", "Sardegna", "Sicilia", "Toscana",
  "Trentino-Alto Adige", "Umbria", "Valle d'Aosta", "Veneto"];
export const QUOTE_STATUS = {
  nuova: { label: "Nuova", cls: "st-live" },
  preventivo_inviato: { label: "Preventivo inviato", cls: "st-attesa" },
  accettata: { label: "Accettata", cls: "st-coda" },
  chiusa: { label: "Chiusa", cls: "st-done" },
};
